import {
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Dialog,
  Divider,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useMemo, useState } from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Ribbon from "./Ribbon";
import BatchTable from "./BatchTable";
import useFilter from "./useFilter";
import StyledDialog from "./StyledDialog";
import useBatchDetails from "./useBatchDetails";
import { useDispatch, useSelector } from "react-redux";
import { getFeaturesAccess } from "../../../../containers/actions/common/accessControl";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const displayLoading = (
  <div style={{ textAlign: "center", marginTop: "10em" }}>
    <CircularProgress color='primary' thickness={7} />
  </div>
);

const displayError = (
  <Box
    style={{
      border: "2px solid rgb(255,0,0)",
      backgroundColor: "rgb(255,240,240)",
      opacity: 1,
      textAlign: "center",
      padding: "0.8rem",
      fontSize: "0.875rem",
      marginBottom: "1.5em",
    }}
  >
    <Typography variant='body2'>
      Something went wrong. Please try again later.
    </Typography>
  </Box>
);

export default function InventoryReconciliation({
  setReconDialog,
  vendorData,
}) {
  //console.log("Vendor Data", vendorData);
  const classes = useStyles();
  const [filterDialog, setFilterDialog] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  // const [saveDialog, setSaveDialog] = useState("");
  // console.log("🚀 ~ InventoryReconciliation ~ saveDialog:", saveDialog);
  const {
    filter,
    setFilter,
    clearFilters,
    handleChange,
    filterLoading,
    saveFilters,
  } = useFilter(setFilterDialog);

  const {
    batchDetails,
    batchLoading,
    batchError,
    handleSave,
    saveDialog,
    setRefresh,
    hasChanges,
    setSaveDialog,
    handleReason,
    selectedReasons,
  } = useBatchDetails(filter, vendorData);
  // console.log("🚀 ~ InventoryReconciliation ~ saveDialog:", saveDialog);

  const screenAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess?.data
        .inventoryReconciliationDashboard
  );
  const featuresAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.featuresAccess
        .inventoryReconciliationDashboardFeature
  );
  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess)
      dispatch(
        getFeaturesAccess(
          screenAccess?.screenId,
          "inventoryReconciliationDashboardFeature"
        )
      );
  }, [dispatch, screenAccess, featuresAccess]);

  const getDialogProps = () => {
    if (filterDialog === "success") {
      return {
        handleClose: () => setFilterDialog(""),
        icon: false,
        title: "Success",
        subtitle: "Filters have been saved successfully.",
      };
    } else if (filterDialog === "error") {
      return {
        handleClose: () => setFilterDialog(""),
        icon: true,
        title: "Failure",
        subtitle: "Failed to save filters",
      };
    } else if (saveDialog === "success") {
      return {
        handleClose: () => setSaveDialog(""),
        icon: false,
        title: "Success",
        subtitle: "Changes have been saved successfully.",
      };
    } else if (saveDialog === "error") {
      return {
        handleClose: () => setSaveDialog(""),
        icon: true,
        title: "Failure",
        subtitle: "Failed to save changes",
      };
    }
    return null;
  };

  const dialogProps = getDialogProps();
  const handleBack = () => {
    setReconDialog(false);
  };
  return (
    <Container maxWidth={false} style={{ width: "100%" }}>
      <Box
        style={{ marginTop: "1em", display: "flex", gap: "1em" }}
      // onClick={handleBack}
      >
        <Typography
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={handleBack}
        >
          <ArrowBackIosIcon />
          Back
        </Typography>
        <Typography variant='h5' style={{ fontWeight: 600 }}>
          Reconciliation of Inventory
        </Typography>
      </Box>
      <Divider style={{ margin: "1em 0" }} />

      <Backdrop
        className={classes.backdrop}
        open={filterLoading || batchLoading}
      // onClick={handleClose}
      >
        <CircularProgress color='inherit' />
      </Backdrop>

      <Dialog open={!!dialogProps} fullWidth={true} maxWidth='xs'>
        {dialogProps && (
          <StyledDialog
            handleClose={dialogProps.handleClose}
            icon={dialogProps.icon}
            title={dialogProps.title}
            subtitle={dialogProps.subtitle}
          />
        )}
      </Dialog>

      <>
        <Ribbon
          filter={filter}
          setFilter={setFilter}
          clearFilters={clearFilters}
          handleChange={handleChange}
          saveFilters={saveFilters}
          filterLoading={filterLoading}
          vendorData={vendorData}
        />
        <BatchTable
          filter={filter}
          batchDetails={batchDetails}
          handleSave={handleSave}
          setRefresh={setRefresh}
          handleReason={handleReason}
          selectedReasons={selectedReasons}
          vendorData={vendorData}
          featuresAccess={featuresAccess}
          batchLoading={batchLoading}
          hasChanges={hasChanges}
        />
      </>
      {/* )} */}
    </Container>
  );
}
